import { getCloudinaryFullPath } from "../../utils";
import { capitalize } from "../../utils/string";

const cap = (text) => (text ? capitalize(text) : "");

/**
 * The bride or the groom on a theme's couple page: their portrait, role, name, parents,
 * home town, phone and a line about them (the same details the shared CoupleInfo shows).
 * Shared by Royal Mahal and Rang Utsav; each theme styles the same markup in its own CSS.
 *
 * - `prefix`     the start of every class name ("rm" for Royal Mahal, "ut" for Rang Utsav)
 * - `Reveal`     the theme's scroll-reveal wrapper
 * - `Frame`      the theme's portrait frame; it is given className, src, alt and `mirror`
 *                (true for the groom, so a frame can face the bride)
 * - `pathname`   the invite's pathname, for lines only some invites carry
 * - `hidePhone`  hides the phone (portfolio views); `hidePhoto` drops the portrait when the
 *                couple's photo is shown instead
 */
const Person = ({
  prefix,
  Reveal,
  Frame,
  data = {},
  isGroom,
  hidePhone,
  hidePhoto,
  pathname,
  delay,
}) => (
  <Reveal className={`${prefix}-person`} delay={delay}>
    {data.photo && !hidePhoto && (
      <Frame className={`${prefix}-person__portrait`} src={getCloudinaryFullPath(data.photo)} alt={cap(data.name)} mirror={isGroom} />
    )}
    <p className={`${prefix}-kicker ${prefix}-person__role`}>{isGroom ? "The Groom" : "The Bride"}</p>
    <h3 className={`${prefix}-person__name`}>{cap(data.name)}</h3>
     {data.grandMotherName && data.grandFatherName && (
      <p className={`${prefix}-person__parents`}>
        {isGroom ? "Grand S/o" : "Grand D/o"} {cap(data.grandMotherName)} & {cap(data.grandFatherName)}
      </p>
    )}
    <p className={`${prefix}-person__parents`}>
      {isGroom ? "S/o" : "D/o"}
      {data.motherName && <span className={`${prefix}-nowrap`}> {cap(data.motherName)}</span>} and {cap(data.fatherName)}
    </p>
    {pathname?.includes("Etasha-Pulkit") && (
      <p className={`${prefix}-person__parents`}>
        {isGroom
          ? "Grand S/o Late Shri Dalchand Ji Bhandari & Late Smt. Khyali Bai Ji Bhandari"
          : "Grand D/o Late Smt. Kamla Devi & Late Shri Basantilal Choudhary"}
      </p>
    )}
    {data.nativePlace && <p className={`${prefix}-person__meta`}>From {data.nativePlace}</p>}
    {data.phone && !hidePhone && (
      <p className={`${prefix}-person__meta`}>
        <a href={`tel:${data.phone}`}>{data.phone}</a>
      </p>
    )}
    {data.about && <p className={`${prefix}-person__about`}>{data.about}</p>}
  </Reveal>
);

export default Person;
